/**
 * shortlist button feature for customers
 */

if (!customElements.get("shortlist-button")) {
  customElements.define(
    "shortlist-button",

    class shortlistButton extends HTMLElement {
      constructor() {
        super();

        this.shortlistStore = {
          /**
           * @type Array<{productHandle: string, variant?:string}>
           */
          items: [],
        };

        this.productHandle = "";
        this.productHasVariants = false;
        this.currentVariant = undefined;
      }

      connectedCallback() {
        /* first, check shortlisted items */
        const _shortlistString = localStorage.getItem("xtra__shortlist");

        try {
          const _shortlistData = JSON.parse(_shortlistString);
          if (Array.isArray(_shortlistData.items)) {
            // shortlistStore initialised, can compare
            this.shortlistStore = _shortlistData;
          }
        } catch (err) {
          // error parsing JSON, just reset the store;
          this.shortlistStore.items = [];
          this.saveShortlistStoreToLocalStorage();
        }

        /* get product handle */
        const a = document.querySelector("[data-product-handle]");
        if (a === null) {
          // does not have any element with product handle, abort
          return;
        }
        this.productHandle = a.getAttribute("data-product-handle");

        /* listen to variant selection */
        const variantOptionsElem = document.querySelector("variant-options");

        if (variantOptionsElem?.currentVariant) {
          const initialVariant = variantOptionsElem.currentVariant.id;
          this.currentVariant = initialVariant;
          this.productHasVariants = true;

          variantOptionsElem.addEventListener(
            "variantChangeEnd",
            function (e) {
              this.currentVariant = e.target.currentVariant.id;
              this.updateButtonState();
            }.bind(this),
          );
        }

        this.addEventListener("click", this.handleClick);
        this.updateButtonState();
      }

      saveShortlistStoreToLocalStorage() {
        localStorage.setItem(
          "xtra__shortlist",
          JSON.stringify(this.shortlistStore),
        );
      }

      updateButtonState() {
        if (!Array.isArray(this.shortlistStore.items)) {
          return;
        }

        const matchingItem = this.shortlistStore.items.find((item) => {
          if (item.productHandle === this.productHandle) {
            if (this.productHasVariants) {
              return item.variant === this.currentVariant;
            } else {
              return true;
            }
          }
        });

        if (matchingItem === undefined) {
          // no item with matching product handle, safe to assume not shortlisted
          this.removeAttribute("data-shortlisted");
        } else {
          if (!this.productHasVariants) {
            // non variants product, safe to assume this is shortlisted
            this.setAttribute("data-shortlisted", "true");
          } else {
            // has variants, check variants too
            if (matchingItem.variant === this.currentVariant) {
              this.setAttribute("data-shortlisted", "true");
            } else {
              this.removeAttribute("data-shortlisted");
            }
          }
        }
      }

      handleClick() {
        if (this.getAttribute("data-shortlisted") !== null) {
          // remove item in shortlistStore

          const removeIdx = this.shortlistStore.items.findIndex(
            function (wi) {
              if (wi.productHandle === this.productHandle) {
                if (this.productHasVariants) {
                  return wi.variant === this.currentVariant;
                } else {
                  return true;
                }
              }
            }.bind(this),
          );

          if (removeIdx > -1) {
            this.shortlistStore.items.splice(removeIdx, 1);

            vanillaToast.show("Removed from shortlist", { immediately: true });
          }
        } else {
          this.shortlistStore.items.push(
            this.productHasVariants
              ? {
                  productHandle: this.productHandle,
                  variant: this.currentVariant,
                }
              : {
                  productHandle: this.productHandle,
                },
          );

          vanillaToast.show("Added to shortlist", { immediately: true });
        }

        this.saveShortlistStoreToLocalStorage();
        this.updateButtonState();
      }
    },
  );
}
